import React, { useState, useEffect, useRef } from 'react'
import { InputDiv, Label, Input, SearchOptions, Option } from '../../styles/select-style'
import ApiService from '../../../services/ApiService'
import { CompanyItemType } from './types'
import { CertificateType } from '../../../pages/ClientPanel/Certificates/CreateCertificate'

type PropsType = {
  certificate: CertificateType,
  setCertificate: React.Dispatch<React.SetStateAction<CertificateType>>,
  structuringCompleted: boolean
}

const SelectSupplierInCertificate:React.FC<PropsType> = ({certificate, setCertificate, structuringCompleted}) => {
  const [ items, setItems ] = useState<CompanyItemType[]>([])
  const [ inputItem, setInputItem ] = useState<string>('')
  const [ showOptions, setShowOptions ] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const optionsRef = useRef<HTMLUListElement>(null)
  const [ selectedIndex, setSelectedIndex ] = useState(0)
  
  useEffect(() => {
    setInputItem(certificate.supplier.companyName || certificate.supplier.contactName || '')
  }, [certificate.supplier.id])
  
  useEffect(() => {
    setSelectedIndex(0)
    const handle = setTimeout(() => {
      ApiService.companies.findAll({
        query: inputItem,
        companyType: 'Fornecedor'
      })
        .then((response: any) => {
          if(response.data) setItems(response.data)
        })
        .catch((error: any) => {
          console.log(error)
        })
    }, 300)

    return () => clearTimeout(handle)
  }, [inputItem])
  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (
        optionsRef.current &&
        inputRef.current &&
        !optionsRef.current.contains(target) &&
        !inputRef.current.contains(target)
      ) {
        setShowOptions(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputItem(e.target.value)
  }

  const handleSelectItem = (item: CompanyItemType) => {
    setInputItem(item.companyName || item.contactName || '')
    setShowOptions(false)
    setCertificate((prev: CertificateType) => ({
      ...prev,
      supplier: item
    }))
  }
  
  const handleSetOptionByKey = (e:React.KeyboardEvent) => {
    if(e.key === 'ArrowDown' && selectedIndex < items.length - 1) setSelectedIndex(prev => prev + 1)
    if(e.key === 'ArrowUp' && selectedIndex > 0) setSelectedIndex(prev => prev - 1)
    if(e.key === 'Enter') handleSelectItem(items[selectedIndex])
    if(e.key === 'Tab') setShowOptions(false)
  }

  return(
    <InputDiv>
      <Label>Fornecedor</Label>
      <Input 
        ref={inputRef}
        type='text' 
        placeholder='Selecione'
        value={inputItem}
        onFocus={() => setShowOptions(true)}
        onChange={handleChangeInput}
        onKeyDown={(e) => handleSetOptionByKey(e)}
        disabled={structuringCompleted}
      />
      {showOptions && 
        <SearchOptions ref={optionsRef}>
          {items.map((s, index) => 
            <Option 
              key={index}
              onClick={() => handleSelectItem(s)}
              isSelected={index === selectedIndex}
            >
              {s.companyName || s.contactName}
            </Option>
          )}
        </SearchOptions>
      }
    </InputDiv>
  )
}

export default SelectSupplierInCertificate

